import React, { PropsWithChildren, type ReactElement } from 'react';

import { LoaderBox } from './styles';

export function ButtonLoader({ children }: PropsWithChildren): ReactElement {
  return (
    <LoaderBox>
      {children}
    </LoaderBox>
  );
}
